import './Slider.css';

export default function Slider({
  label,
  labelLow,
  labelHigh,
  value = 50,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  id,
  className = '',
  ...props
}) {
  const inputId = id || `slider-${Math.random().toString(36).substr(2, 9)}`;
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className={`slider-group ${className}`}>
      {label && (
        <label htmlFor={inputId} className="slider-group__label">
          {label}
        </label>
      )}
      <div className="slider-group__labels">
        <span className="slider-group__label-low">{labelLow}</span>
        <span className="slider-group__value">{value}</span>
        <span className="slider-group__label-high">{labelHigh}</span>
      </div>
      <div className="slider-group__track-wrapper">
        <input
          type="range"
          id={inputId}
          className="slider-group__input"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange?.(parseInt(e.target.value, 10))}
          style={{
            '--slider-percentage': `${percentage}%`
          }}
          {...props}
        />
        <div 
          className="slider-group__fill" 
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
